import React from 'react';
import styled from 'styled-components';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { colors } from '../../utils/colors.js';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  margin-top: 12px;
  background: ${colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
  gap: 12px;
`;

const Info = styled.div`
  font-size: 13px;
  color: ${colors.gray[500]};
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid ${colors.gray[300]};
  background: ${colors.white};
  color: ${colors.gray[700]};
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const PageIndicator = styled.span`
  font-size: 13px;
  color: ${colors.gray[700]};
  padding: 0 4px;
`;

const PerPageSelect = styled.select`
  border: 1px solid ${colors.gray[300]};
  border-radius: 8px;
  padding: 5px 8px;
  font-size: 13px;
  color: ${colors.gray[700]};
`;

export default function Pagination({ page, perPage, total, onPageChange, onPerPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <Bar>
      <Info>
        {total} registro{total === 1 ? '' : 's'} — página {page} de {totalPages}
      </Info>
      <Controls>
        <PerPageSelect value={perPage} onChange={(e) => onPerPageChange(Number(e.target.value))}>
          <option value={10}>10 / página</option>
          <option value={20}>20 / página</option>
          <option value={50}>50 / página</option>
        </PerPageSelect>
        <PageButton disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          <FaChevronLeft size={12} />
        </PageButton>
        <PageIndicator>{page}</PageIndicator>
        <PageButton disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
          <FaChevronRight size={12} />
        </PageButton>
      </Controls>
    </Bar>
  );
}
